export default {
	"locale": "pt",
	"long": {
		"year": {
			"previous": "ano passado",
			"current": "este ano",
			"next": "próximo ano",
			"past": {
				"one": "há {0} ano",
				"other": "há {0} anos"
			},
			"future": {
				"one": "em {0} ano",
				"other": "em {0} anos"
			}
		},
		"quarter": {
			"previous": "último trimestre",
			"current": "este trimestre",
			"next": "próximo trimestre",
			"past": {
				"one": "há {0} trimestre",
				"other": "há {0} trimestres"
			},
			"future": {
				"one": "em {0} trimestre",
				"other": "em {0} trimestres"
			}
		},
		"month": {
			"previous": "mês passado",
			"current": "este mês",
			"next": "próximo mês",
			"past": {
				"one": "há {0} mês",
				"other": "há {0} meses"
			},
			"future": {
				"one": "em {0} mês",
				"other": "em {0} meses"
			}
		},
		"week": {
			"previous": "semana passada",
			"current": "esta semana",
			"next": "próxima semana",
			"past": {
				"one": "há {0} semana",
				"other": "há {0} semanas"
			},
			"future": {
				"one": "em {0} semana",
				"other": "em {0} semanas"
			}
		},
		"day": {
			"previous": "ontem",
			"previous-2": "anteontem",
			"current": "hoje",
			"next": "amanhã",
			"next-2": "depois de amanhã",
			"past": {
				"one": "há {0} dia",
				"other": "há {0} dias"
			},
			"future": {
				"one": "em {0} dia",
				"other": "em {0} dias"
			}
		},
		"hour": {
			"current": "esta hora",
			"past": {
				"one": "há {0} hora",
				"other": "há {0} horas"
			},
			"future": {
				"one": "em {0} hora",
				"other": "em {0} horas"
			}
		},
		"minute": {
			"current": "este minuto",
			"past": {
				"one": "há {0} minuto",
				"other": "há {0} minutos"
			},
			"future": {
				"one": "em {0} minuto",
				"other": "em {0} minutos"
			}
		},
		"second": {
			"current": "agora",
			"past": {
				"one": "há {0} segundo",
				"other": "há {0} segundos"
			},
			"future": {
				"one": "em {0} segundo",
				"other": "em {0} segundos"
			}
		}
	},
	"short": {
		"year": {
			"previous": "ano passado",
			"current": "este ano",
			"next": "próximo ano",
			"past": {
				"one": "há {0} ano",
				"other": "há {0} anos"
			},
			"future": {
				"one": "em {0} ano",
				"other": "em {0} anos"
			}
		},
		"quarter": {
			"previous": "último trimestre",
			"current": "este trimestre",
			"next": "próximo trimestre",
			"past": "há {0} trim.",
			"future": "em {0} trim."
		},
		"month": {
			"previous": "mês passado",
			"current": "este mês",
			"next": "próximo mês",
			"past": {
				"one": "há {0} mês",
				"other": "há {0} meses"
			},
			"future": {
				"one": "em {0} mês",
				"other": "em {0} meses"
			}
		},
		"week": {
			"previous": "semana passada",
			"current": "esta semana",
			"next": "próxima semana",
			"past": "há {0} sem.",
			"future": "em {0} sem."
		},
		"day": {
			"previous": "ontem",
			"previous-2": "anteontem",
			"current": "hoje",
			"next": "amanhã",
			"next-2": "depois de amanhã",
			"past": {
				"one": "há {0} dia",
				"other": "há {0} dias"
			},
			"future": {
				"one": "em {0} dia",
				"other": "em {0} dias"
			}
		},
		"hour": {
			"current": "esta hora",
			"past": "há {0} h",
			"future": "em {0} h"
		},
		"minute": {
			"current": "este minuto",
			"past": "há {0} min.",
			"future": "em {0} min."
		},
		"second": {
			"current": "agora",
			"past": "há {0} seg.",
			"future": "em {0} seg."
		}
	},
	"narrow": {
		"year": {
			"previous": "ano passado",
			"current": "este ano",
			"next": "próximo ano",
			"past": {
				"one": "há {0} ano",
				"other": "há {0} anos"
			},
			"future": {
				"one": "em {0} ano",
				"other": "em {0} anos"
			}
		},
		"quarter": {
			"previous": "último trimestre",
			"current": "este trimestre",
			"next": "próximo trimestre",
			"past": "há {0} trim.",
			"future": "em {0} trim."
		},
		"month": {
			"previous": "mês passado",
			"current": "este mês",
			"next": "próximo mês",
			"past": {
				"one": "há {0} mês",
				"other": "há {0} meses"
			},
			"future": {
				"one": "em {0} mês",
				"other": "em {0} meses"
			}
		},
		"week": {
			"previous": "semana passada",
			"current": "esta semana",
			"next": "próxima semana",
			"past": "há {0} sem.",
			"future": "em {0} sem."
		},
		"day": {
			"previous": "ontem",
			"previous-2": "anteontem",
			"current": "hoje",
			"next": "amanhã",
			"next-2": "depois de amanhã",
			"past": {
				"one": "há {0} dia",
				"other": "há {0} dias"
			},
			"future": {
				"one": "em {0} dia",
				"other": "em {0} dias"
			}
		},
		"hour": {
			"current": "esta hora",
			"past": "há {0} h",
			"future": "em {0} h"
		},
		"minute": {
			"current": "este minuto",
			"past": "há {0} min.",
			"future": "em {0} min."
		},
		"second": {
			"current": "agora",
			"past": "há {0} seg.",
			"future": "em {0} seg."
		}
	},
	"now": {
		"now": {
			"current": "agora",
			"future": "em instantes",
			"past": "agora mesmo"
		}
	},
	"mini": {
		"year": "{0}ano",
		"month": "{0}mes",
		"week": "{0}sem.",
		"day": "{0} d",
		"hour": "{0} h",
		"minute": "{0} m",
		"second": "{0} s",
		"now": "agora"
	},
	"long-time": {
		"year": {
			"one": "{0} ano",
			"other": "{0} anos"
		},
		"month": {
			"one": "{0} mês",
			"other": "{0} meses"
		},
		"week": {
			"one": "{0} semana",
			"other": "{0} semanas"
		},
		"day": {
			"one": "{0} dia",
			"other": "{0} dias"
		},
		"hour": {
			"one": "{0} hora",
			"other": "{0} horas"
		},
		"minute": {
			"one": "{0} minuto",
			"other": "{0} minutos"
		},
		"second": {
			"one": "{0} segundo",
			"other": "{0} segundos"
		}
	}
}